var picmonicng = angular
  .module('picmonicng', [
    'picmonic-common',
    'ngFileUpload',
    'uiCropper',
    'toaster',
    'jtt_youtube',
    'froala',
    'angular-md5',
    'duScroll',
    'angular.filter',
    'hal-common',
    'ngInputModified',
    'material.core',
    'material.components.backdrop',
    'material.components.button',
    'material.components.datepicker',
    'material.components.icon',
    'material.components.input',
    'material.components.select',
    'material.components.showHide',
    'material.components.slider',
    'material.components.virtualRepeat',
    'material.components.progressCircular',
    'ngTextTruncate',
    'angularPayments',
  ])
  .config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    function ($stateProvider, $urlRouterProvider, $locationProvider) {
      $stateProvider
        .state('lti_selection', {
          url: '/lti/select?launch_presentation_return_url&lti_id&request_id&d2l&context_id&data&launch_id&school_class_id',
          v1Only: true,
          views: {
            'template@': {
              component: 'ltiSelectionComponent',
            },
          },
        })
        .state('lti_selection_public', {
          url: '/lti/selection?launch_presentation_return_url&lti_id&request_id&d2l&context_id&data&launch_id&school_class_id',
          params: {
            no_lms: true,
          },
          v1Only: true,
          views: {
            'template@': {
              component: 'ltiSelectionComponent',
            },
          },
        })
        .state('lti_submission_detail', {
          url: '/lti/submission_details?id',
          v1Only: true,
          views: {
            'template@': {
              component: 'ltiSubmissionDetailComponent',
            },
          },
        })
        .state('app', {
          url: '?browseOpen&searchOpen&q',
          params: {
            browseOpen: {
              dynamic: true,
            },
            searchOpen: {
              dynamic: true,
            },
          },
          abstract: true,
          views: {
            nav: {
              templateUrl: function () {
                var version = angular.element(document.body).injector().get('$cookies').get('picmonic_version') || 'v2';
                return version === 'v1' ? '/templates/partials/nav.html' : '/templates/partials/nav.v2.html';
              },
              controller: 'NavigationController',
            },
          },
        })
        .state('app.404', {
          views: {
            'template@': {
              templateUrl: '/templates/pages/auth/404.html',
              controller: '404Controller',
            },
          },
        })
        .state('app.apphome', {
          url: '/home?browse&browseParams&browseOpen&browseOptions&invite_students',
          views: {
            'template@': {
              component: 'homeComponent',
            },
          },
        })
        .state('app.learn404', {
          url: '/learn/404?:query',
          params: {
            error: null,
            suggested: null,
            query: null,
          },
          views: {
            'template@': {
              templateUrl: '/templates/pages/learn/404.html',
              controller: 'Learn404Controller',
            },
          },
        })
        .state('app.learn', {
          url: '/learn/:slug?nomodal&studyPlan',
          params: {
            nomodal: {
              dynamic: true,
            },
            studyPlan: null,
          },
          resolve: {
            $meta: function () {
              return {
                replacements: {
                  '%LEARN%': 'Learn',
                  '%IMAGE%': 'https://cdn.picmonic.com/cloud_data/production/assets/img/pathways/Anatomy_small.png',
                },
              };
            },
          },
          views: {
            'template@': {
              templateUrl: '/templates/pages/learn/index.html',
              controller: 'LearnController',
            },
          },
        })
        .state('app.editor', {
          url: '/editor/:slug?first_viewing&selectedFactId&newFact',
          params: {
            first_viewing: null,
            newFact: null,
            tab: null,
            returnTo: null,
            returnAfterFact: false,
            selectedFactId: null,
          },
          v1Only: true,
          resolve: {
            resolvedData: [
              '$stateParams',
              '$q',
              'EditorService',
              'LearnService',
              'PusherService',
              function ($stateParams, $q, EditorService, LearnService, PusherService) {
                return $q(function (resolve, reject) {
                  var resolvedData = {};
                  if (LearnService.currentCard && LearnService.currentCard.slug == $stateParams.slug) {
                    resolvedData = {
                      currentCard: LearnService.currentCard,
                      currentFacts: LearnService.currentFacts,
                      workflow: LearnService.workflow,
                    };

                    // Now that we've grabbed the learnservice data, wipe it out so it's not lingering
                    LearnService.currentCard = {};
                    LearnService.currentFacts = [];
                    LearnService.workflow = false;
                    completeResolve();
                  } else {
                    EditorService.getCard($stateParams.slug).then(function (data) {
                      resolvedData = data;
                      completeResolve();
                    });
                  }

                  function completeResolve() {
                    if (resolvedData.currentCard.in_workflow) {
                      var connection = PusherService.subscribe(
                        'presence-editor_card_' + resolvedData.currentCard.card_id
                      );

                      connection.success(function () {
                        resolvedData.pusherConnection = connection;
                        resolve(resolvedData);
                      });
                    } else {
                      resolve(resolvedData);
                    }
                  }
                });
              },
            ],
          },
          views: {
            'template@': {
              templateUrl: '/templates/pages/editor/index.html',
              controller: 'EditorController',
            },
            'nav@': {
              template: '',
            },
          },
        })
        .state('app.ambassador', {
          url: '/ambassador-portal',
          views: {
            'template@': {
              component: 'ambassadorPortalComponent',
            },
          },
          v1Only: true,
        })
        .state('app.achievements', {
          url: '/achievements',
          views: {
            'template@': {
              component: 'achievementsComponent',
            },
          },
          v1Only: true,
        })
        .state('app.lti-dashboard', {
          url: '/lti-dashboard',
          views: {
            'template@': {
              component: 'ltiDashboardComponent',
            },
          },
        })
        .state('app.quiz', {
          url: '/quiz/:quiz_type/:resource_id?pathway_id&track_id&card_id&playlist_id&quiz_all&questions',
          views: {
            'template@': {
              templateUrl: '/templates/pages/learn/index.html',
              controller: 'LearnController',
            },
          },
          resolve: {
            $meta: function () {
              return { replacements: { '%QUIZ%': 'Medicine' } };
            },
          },
        })
        .state('app.schools', {
          url: '/schools',
          views: {
            'template@': {
              templateUrl: '/templates/pages/schools/template.html',
            },
          },
          resolve: {
            $meta: function () {
              return { replacements: { '%SCHOOL%': 'My School' } };
            },
          },
        })
        .state('app.schools.index', {
          url: '/:school_id',
          views: {
            content: {
              templateUrl: '/templates/pages/schools/index.html',
              controller: [
                '$scope',
                '$stateParams',
                function ($scope, $stateParams) {
                  $scope.school_id = $stateParams.school_id;
                },
              ],
            },
          },
        })
        .state('app.schools.playlists', {
          url: '/:school_id/playlists',
          views: {
            content: {
              templateUrl: '/templates/pages/schools/playlists.html',
              controller: [
                '$scope',
                '$stateParams',
                function ($scope, $stateParams) {
                  $scope.school_id = $stateParams.school_id;
                },
              ],
            },
          },
        })
        .state('app.schools.discussions', {
          url: '/:school_id/discussions',
          views: {
            content: {
              templateUrl: '/templates/pages/schools/discussions.html',
              controller: [
                '$scope',
                '$stateParams',
                function ($scope, $stateParams) {
                  $scope.school_id = $stateParams.school_id;
                },
              ],
            },
          },
        })
        .state('app.settings', {
          url: '/settings',
          abstract: true,
          views: {
            'template@': {
              templateUrl: '/templates/pages/profile/template.html',
            },
          },
        })
        .state('app.settings.profile', {
          url: '/profile',
          views: {
            header: {
              templateUrl: '/templates/pages/profile/header.html',
              controller: 'ProfileHeaderController',
            },
            content: {
              templateUrl: '/templates/pages/profile/profile.html',
              controller: 'EditProfileController',
            },
          },
        })
        .state('app.settings.site', {
          url: '/site',
          views: {
            header: {
              templateUrl: '/templates/pages/profile/header.html',
              controller: 'ProfileHeaderController',
            },
            content: {
              templateUrl: '/templates/pages/profile/sitesettings.html',
              controller: 'EditSiteSettingsController',
            },
          },
        })
        .state('app.my-subscriptions', {
          url: '/my-subscriptions',
          abstract: true,
          views: {
            'template@': {
              templateUrl: '/templates/pages/my-subscriptions/template.html',
            },
          },
        })
        .state('app.my-subscriptions.product-access', {
          url: '/product-access',
          views: {
            content: {
              templateUrl: '/templates/pages/my-subscriptions/product-access.html',
              controller: 'MySubscriptionsProductAccessController',
            },
          },
        })
        .state('app.my-subscriptions.order-history', {
          url: '/order-history',
          views: {
            content: {
              templateUrl: '/templates/pages/my-subscriptions/order-history.html',
              controller: 'MySubscriptionsOrderHistoryController',
            },
          },
        })
        .state('app.my-subscriptions.billing-history', {
          url: '/billing-history',
          views: {
            content: {
              templateUrl: '/templates/pages/my-subscriptions/billing-history.html',
              controller: 'MySubscriptionsBillingHistoryController',
            },
          },
        })
        .state('app.my-subscriptions.payment-info', {
          url: '/payment-info?replace',
          views: {
            content: {
              templateUrl: '/templates/pages/my-subscriptions/payment-info.html',
              controller: 'MySubscriptionsPaymentInfoController',
            },
          },
        })
        .state('app.resources', {
          url: '/resources',
          abstract: true,
          views: {
            'template@': {
              templateUrl: '/templates/pages/resources/template.html',
              controller: 'ResourcesController',
            },
          },
          v1Only: true,
        })
        .state('app.resources.tab', {
          url: '/:tab?category',
          params: { tab: 'medicine' },
          views: {
            content: {
              templateUrl: '/templates/public/webinars.html',
              controller: 'WebinarsController',
            },
          },
          resolve: {
            $meta: function () {
              return { replacements: { '%RESOURCE%': 'Loading' } };
            },
          },
          v1Only: true,
        })
        .state('app.notes', {
          url: '/my-notes',
          views: {
            'template@': {
              templateUrl: '/templates/pages/notes/index.html',
              controller: 'MyNotesController',
            },
          },
        })
        .state('app.educator-dashboard', {
          url: '/educator',
          views: {
            'template@': {
              templateUrl: '/templates/pages/educator/index.html',
              controller: 'EducatorDashboardController',
            },
          },
        })
        .state('app.educator-data', {
          url: '/educator/data',
          views: {
            'template@': {
              component: 'educatorDataComponent',
            },
          },
        })
        .state('app.my-picmonics', {
          url: '/my-picmonics?create',
          views: {
            'template@': {
              templateUrl: '/templates/pages/my-picmonics/index.html',
              controller: 'MyPicmonicsController',
            },
          },
        })
        .state('app.search', {
          url: '/search?q',
          params: {
            q: {
              dynamic: true,
            },
          },
          views: {
            'template@': {
              templateUrl: '/templates/pages/search/index.html',
              controller: 'SearchController',
            },
          },
        })
        .state('app.find-picmonic', {
          url: '/find-picmonic?browse&browseParams&market&pathway&path&pathway_type&curriculum',
          views: {
            'template@': {
              templateUrl: '/templates/pages/find-picmonic.html',
              controller: 'FindPicmonicController',
            },
          },
        })
        .state('app.schedule', {
          url: '/schedule',
          views: {
            'template@': {
              component: 'homeStudyScheduler',
            },
          },
          v1Only: true,
        })
        .state('app.characters', {
          url: '/characters?query',
          v1Only: true,
          views: {
            'template@': {
              templateUrl: '/templates/pages/characters/index.html',
              controller: 'CharactersController',
            },
          },
          resolve: {
            launchDarkly: [
              'UserService',
              '$state',
              '$q',
              function (UserService, $state, $q) {
                return $q(function (resolve) {
                  UserService.canSeeGlossary() ? resolve(true) : $state.go('app.404', null, { location: false });
                });
              },
            ],
          },
          v1Only: true,
        });

      $urlRouterProvider
        .when('/my-subscriptions/billing-history', '/my-subscriptions/order-history')
        .when('/stats', '/home')
        .when('/educator', '/home')
        .when('/', '/home')
        .when('/quiz/spacedrep', '/quiz/spacedrep/today')
        .when('/educator/data', '/home')
        .when('/resources', [
          'UserService',
          '$state',
          'MarketOptionsConfig',
          'MarketSelectorModalService',
          '$cookies',
          '$location',
          function (UserService, $state, MarketOptionsConfig, MarketSelectorModalService, $cookies) {
            if (UserService.user.user_id) {
              location = '/pricing/' + MarketOptionsConfig.getMarketById(UserService.user.lead).slug;
              return;
            }

            var marketselector = MarketSelectorModalService.showMarketSelectorModal(null, true, true);
            marketselector.result.then(function (result) {
              location = '/pricing/' + MarketOptionsConfig.getMarketById($cookies.get('pls_user_lead')).slug;
            });
          },
        ])
        .otherwise(function ($injector, $location) {
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('404', document.location);
          }
          var state = $injector.get('$state');
          state.go('app.404', null, { location: false });

          return $location.path();
        });

      $urlRouterProvider.rule(function ($injector, $location) {
        var path = $location.path();
        var hasTrailingSlash = path[path.length - 1] === '/';

        if (hasTrailingSlash) {
          //if last charcter is a slash, return the same url without the slash
          return path.substr(0, path.length - 1);
        }
      });

      $locationProvider.html5Mode({
        enabled: true,
        requireBase: false,
      });
    },
  ])
  .config([
    '$compileProvider',
    function ($compileProvider) {
      $compileProvider.debugInfoEnabled(false);
    },
  ])
  .config([
    '$compileProvider',
    function ($compileProvider) {
      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|picmonic):/);
    },
  ])
  .config([
    '$provide',
    function ($provide) {
      $provide.decorator('$exceptionHandler', [
        '$delegate',
        'RaygunService',
        function ($delegate, RaygunService) {
          return function (exception, cause) {
            $delegate(exception, cause);
            RaygunService.sendException(exception);
          };
        },
      ]);
    },
  ])
  .config([
    '$mdThemingProvider',
    function ($mdThemingProvider) {
      $mdThemingProvider.theme('default').primaryPalette('orange').accentPalette('blue');
    },
  ])
  .config([
    '$resourceProvider',
    function ($resourceProvider) {
      $resourceProvider.defaults.cancellable = true;
    },
  ])
  .config([
    'hotkeysProvider',
    function (hotkeysProvider) {
      hotkeysProvider.useNgRoute = false;
      hotkeysProvider.template =
        '<div class="cfp-hotkeys-container fade" ng-class="{in: helpVisible}" style="display: none;"><div class="cfp-hotkeys">' +
        '<h4 class="cfp-hotkeys-title" ng-if="!header">{{ title }}</h4>' +
        '<div ng-bind-html="header" ng-if="header"></div>' +
        '<table><tbody>' +
        '<tr ng-repeat="hotkey in hotkeys | filter:{ description: \'!$$undefined$$\' }">' +
        '<td class="cfp-hotkeys-keys">' +
        '<span ng-repeat="key in hotkey.format() track by $index" class="cfp-hotkeys-key">{{ key }}</span>' +
        '</td>' +
        '<td class="cfp-hotkeys-text">{{ hotkey.description }}</td>' +
        '</tr>' +
        '</tbody></table>' +
        '<div ng-bind-html="footer" ng-if="footer"></div>' +
        '<div class="cfp-hotkeys-close" ng-click="toggleCheatSheet()">&#215;</div>' +
        '</div></div>';
    },
  ])
  .run([
    'UserService',
    '$rootScope',
    '$location',
    '$http',
    'SplitTestService',
    '$cookies',
    function (UserService, $rootScope, $location, $http, SplitTestService, $cookies) {
      $rootScope.bodyClass = [];
      if ($cookies.get('picmonic_version') != 'v1') {
        $rootScope.bodyClass.push('v2-nav');
        if ($cookies.get('color_mode') !== 'dark') {
          $rootScope.bodyClass.push('light');
        }
      }
      var inIframe = false;
      try {
        inIframe = window.self !== window.top;
      } catch (e) {
        inIframe = true;
      }

      if (inIframe) {
        $rootScope.embed = true;
        $rootScope.bodyClass.push('embed');
        if (UserService.user.user_id) {
          UserService.user.settings.learn_theater = 1;
          UserService.user.quiz_show_ratings = 0;
        }
      }
      if (
        UserService.user &&
        UserService.user.settings &&
        UserService.user.settings.set_email &&
        UserService.user.lti &&
        UserService.user.lti.lti_id
      ) {
        //var split  = UserService.user.lti.lti_id == 4 ? SplitTestService.split('wk_reg_value', ['a','b']) : 'a';
        //UserService.showTOSModal(split);
        UserService.showTOSModal('a');
      }
    },
  ])
  .run([
    '$transitions',
    'BrowseService',
    '$rootScope',
    '$modalStack',
    'Navigation',
    'UserService',
    'LearnService',
    'EditorService',
    '$cookies',
    '$window',
    function (
      $transitions,
      BrowseService,
      $rootScope,
      $modalStack,
      Navigation,
      UserService,
      LearnService,
      EditorService,
      $cookies,
      $window
    ) {
      $transitions.onStart({}, function (trans) {
        var params = angular.copy(trans.params());
        if (params.browseOpen) {
          delete params.browseOpen;
          BrowseService.state = 'home';
          BrowseService.setOpen(true);
          return trans.router.stateService.target(trans.to().name, params);
        } else if (!trans.originalTransition().params().browseOpen) {
          BrowseService.setOpen(false);
        }
      });
      $transitions.onStart({}, function (trans) {
        //flag to refresh page if new js has been deployed
        if ($rootScope.refresh) {
          window.location = trans.router.stateService.href(trans.to().name, trans.params('to'));
          return false;
        }

        $modalStack.dismissAll();

        if (!Navigation.topVisible) {
          Navigation.topVisible = true;
        }

        if ($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile') !== -1) {
          $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile'), 1);
        }

        if ($rootScope.bodyClass.indexOf('nav-hidden-mobile') !== -1) {
          $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('nav-hidden-mobile'), 1);
        }
      });
      $transitions.onExit({ from: 'app.learn' }, function (trans) {
        var toState = trans.$to();
        var toParams = trans.params('to');
        LearnService.saveVisibleSegments();
        if (UserService.user.user_id && LearnService.currentCard.is_owned && !LearnService.quiz) {
          LearnService.saveCardAttempt(0);
        }

        if (
          LearnService.fullscreen &&
          toState.name != 'app.learn' &&
          (toState.name != 'app.quiz' || window.innerWidth < 768)
        ) {
          LearnService.toggleFullscreen();
        }

        if (toState.name != 'app.learn') {
          LearnService.reset();

          // If going to the editor, leave learnservice data alone so we can retrieve it in editorservice.
          // This data wipe will be done in the route resolve instead
          if (
            (toState.name != 'app.editor' && toState.name != 'app.quiz') ||
            (toState.name == 'app.quiz' && toParams.resource_id != LearnService.currentCard.slug) ||
            (toState.name == 'app.editor' && toParams.slug != LearnService.currentCard.slug)
          ) {
            LearnService.currentCard = {};
            LearnService.currentFacts = [];
            LearnService.clearCardCache();
          }
        }
      });

      $transitions.onExit({ from: 'app.quiz' }, function (trans) {
        var toState = trans.$to();
        var toParams = trans.params('to');

        if (LearnService.fullscreen && toState.name != 'app.learn' && toState.name != 'app.quiz') {
          LearnService.toggleFullscreen();
        }
      });

      $transitions.onStart({ from: 'app.editor' }, function (trans) {
        if (EditorService.history.length > 1) {
          if (!confirm('You have unsaved changes!\nAre you sure you want to exit?')) {
            event.preventDefault();
            return false;
          }
        }

        EditorService.reset();
        EditorService.clearHistory();
      });

      $transitions.onStart({ to: 'app.editor' }, function (trans) {
        Navigation.topVisible = false;
      });

      $transitions.onStart({}, function (trans) {
        var to = trans.$to();
        if ($cookies.get('picmonic_version') != 'v1' && !to.v1Only && !to.name.includes('admin')) {
          window.location = trans.router.stateService.href(to.name, trans.params('to'));
          return false;
        }
      });
    },
  ])
  .run([
    '$rootScope',
    '$templateCache',
    'UserService',
    'SplitTestService',
    function ($rootScope, $templateCache, UserService, SplitTestService) {
      // Avoid anchor tag issues on UI-Bootstrap Typeahead
      $templateCache.put(
        'template/typeahead/typeahead-match.html',
        '<a tabindex="-1" bind-html-unsafe="match.label | typeaheadHighlight:query"></a>\n'
      );

      if (UserService.user.user_id) {
        if (!UserService.user.lead) {
          document.location.href = '/?register=1';
        }

        //PlaylistService.init();
        UserService.getRecommendations();
      }

      // Allow educators to select text
      if (UserService.user.user_id && UserService.user.role === 'Professor') {
        angular.element('body')[0].style['user-select'] = 'auto';
      }
    },
  ]);
